import {
  AbsolutesWhiteColors,
  BackgroundColors,
  PositiveColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Easing } from '@picsart/design-system/foundation/easing';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      paddingTop: 360,
      paddingBottom: 70,
      backgroundImage: `linear-gradient(180deg, ${PositiveColors.base.default} 0%, ${BackgroundColors.base} 100%);`,

      [mediaQuery(BreakPoints.Large)]: {
        paddingTop: 293,
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        paddingTop: 250,
      },
    },

    videoTemplateHolder: {
      paddingTop: Spacings.s64,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginLeft: Spacings.s24,
        marginRight: Spacings.s24,
      },
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        margin: Spacings.s0,
      },
    },

    descriptionContent: {
      margin: 'auto',
      maxWidth: 636,
    },

    carouselContainer: {
      position: 'relative',
      marginBottom: Spacings.s56,
      minHeight: 218,
    },

    categoriesFilter: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: Spacings.s40,
    },

    action: {
      padding: [Spacings.s8, Spacings.s64],
      margin: [Spacings.s0, 'auto'],
      width: 'fit-content',
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.bold,
      lineHeight: LineHeights.l20,
      borderWidth: 2,
      '&:focus': {
        outlineOffset: 6,
      },
    },

    description: {
      marginBottom: Spacings.s32,
      textAlign: 'center',

      '& h3': {
        display: '-webkit-box',
        fontSize: FontSizes.s20,
        fontWeight: FontWeights.medium,
        lineHeight: LineHeights.l28,
        textAlign: 'center',
        color: TextColors.base,
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
      },
    },
    title: {
      marginBottom: Spacings.s12,
      fontSize: FontSizes.s36,
      fontWeight: FontWeights.bold,
      lineHeight: LineHeights.l48,
      textAlign: 'center',
      color: TextColors.base,
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        marginBottom: Spacings.s32,
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l32,
      },
    },
    sliderWrapper: {
      minHeight: 258,
    },
    toolItem: {
      minWidth: 320,
      margin: '0 12px',
      filter: `drop-shadow(0px 2px 8px ${BackgroundColors.tint3})`,
      cursor: 'pointer',
    },
    singleTemplate: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden',
      marginBottom: Spacings.s44,
    },
    carouselItem: {
      transition: `transform ${Timings.default} ${Easing.easeInOut}`,
    },
    transformContainer: {
      '&.container': {
        margin: [Spacings.s40, 'auto'],
      },
    },
    carouselControls: {
      position: 'absolute',
      left: Spacings.s0,
      top: Spacings.s0,
      bottom: Spacings.s0,
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: 'auto',
      width: '100%',
      height: 0,

      '& .control': {
        backgroundImage: `linear-gradient(270deg, transparent 0%, ${AbsolutesWhiteColors.base.default} 48.96%, transparent 100%)`,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 218,
        width: 80,

        '&.prev': {
          left: `calc(${Spacings.s40} * -1)`,
        },

        '&.next': {
          right: `calc(${Spacings.s40} * -1)`,
        },
      },
    },
    templatesCarousel: {
      position: 'initial !important',
      minHeight: 220,
      overflow: 'hidden',

      '& > .firstSlider': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },
    tempControls: {
      '&.left': {
        left: '-44px !important',
      },

      '&.right': {
        right: '-44px !important',
      },

      '& button': {
        boxShadow: `0px 4px 8px ${BackgroundColors.tint3}`,
        height: '38px',
      },
    },

    // Skeleton
    skeletonRoot: {
      margin: [Spacings.s0, 'auto'],
    },
    skeletonGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: Spacings.s64,
    },
    grid: {
      width: 320,
      height: 368,
    },
    gridSmall: {
      width: 344,
      height: 218,
      margin: [Spacings.s0, CornerRadius.r8],
    },
    toggleButton: {
      width: 196,
      height: 44,
      margin: [Spacings.s40, 'auto', Spacings.s0],
      borderRadius: 40,
      overflow: 'hidden',
    },
    skeletonButton: {
      height: 40,
      width: 256,
      margin: [Spacings.s56, 'auto', Spacings.s0],
    },
    skeletonTitle: {
      height: 40,
      width: 580,
      margin: [Spacings.s0, 'auto'],
    },
    skeletonDesc: {
      height: 60,
      width: 620,
      marginTop: Spacings.s32,
      margin: [Spacings.s32, 'auto', Spacings.s0],
    },
  }),
  {
    name: 'discover-content',
  },
);

export default useStyles;
